import { useEffect, useState } from "react";

export const TASKBAR_HEIGHT = 48;

const DESKTOP_QUERY = "(min-width: 1024px)";

// Mirrors Tailwind's lg breakpoint: below it the site is a single fullscreen page with no desktop.
export const useIsDesktop = () => {
  const [matches, setMatches] = useState(() => window.matchMedia(DESKTOP_QUERY).matches);

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const onChange = (e) => setMatches(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return matches;
};

export const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), hi);

// Tracks a primary-button drag via pointer capture, reporting deltas from the press point.
export const beginDrag = (e, onMove, onEnd) => {
  if (e.button !== 0) return;

  const el = e.currentTarget;
  const x0 = e.clientX;
  const y0 = e.clientY;

  const move = (ev) => onMove(ev.clientX - x0, ev.clientY - y0);
  const end = () => {
    el.removeEventListener("pointermove", move);
    el.removeEventListener("pointerup", end);
    el.removeEventListener("pointercancel", end);
    onEnd();
  };

  el.setPointerCapture(e.pointerId);
  el.addEventListener("pointermove", move);
  el.addEventListener("pointerup", end);
  el.addEventListener("pointercancel", end);
  e.preventDefault();
};

// localStorage can throw (private mode, blocked storage); positions are a convenience, so degrade to defaults.
export const loadJSON = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? null : JSON.parse(raw);
  } catch (err) {
    console.warn(`Failed to load ${key}:`, err);
    return null;
  }
};

export const saveJSON = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.warn(`Failed to save ${key}:`, err);
  }
};
